"use client";

import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { RichTextEditorLazy } from "../rich-text/rich-text-editor-lazy";

export const ColumnsRichText = ({ content, idx }: { content: unknown; idx: number }) => {
	const { saveSelectedPageSectionField } = useStoreBuilderContext();

	return (
		<RichTextEditorLazy
			content={content || null}
			onChange={(content) => {
				saveSelectedPageSectionField({ fieldPath: `columns.${idx}.content`, value: content });
			}}
		/>
	);
};
